import { render, staticRenderFns } from "./CustomButtons.vue?vue&type=template&id=3e9c4dfd"
import script from "./CustomButtons.vue?vue&type=script&lang=ts"
export * from "./CustomButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports